<template>
    <div>
        <b-input-group>
            <b-input-group-prepend v-if="$attrs.prefix">
                <b-input-group-text> {{ $attrs.prefix }} </b-input-group-text>
            </b-input-group-prepend>
        <b-form-input 
        type="number" 
        :id="field.key" 
        :placeholder="field.constraints.placeholder"
        v-model="content"
        v-bind="$attrs"
        autocomplete="off"
        ></b-form-input>
            <b-input-group-prepend v-if="$attrs.sufix">
                <b-input-group-text> {{ $attrs.sufix }}</b-input-group-text>
            </b-input-group-prepend>
         <b-form-invalid-feedback :id="field.key" style="display:block">
          {{ errors[0] || null }}
        </b-form-invalid-feedback>
        </b-input-group>
    </div>
</template>

<script>
export default {
    name: "IdentityField_Number",
    props: {
        field: {
            type: Object
        },
        value: {
            type: Number
        },
        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: []
        }
    },
    computed: {
        content: {
            get() {
                return this.value;
            },

            set(val) {
                val = parseFloat(val)
                
                this.check(val)

                if (typeof val != 'number') {
                    val = null
                }

                this.$emit('input', val);
            }
        },

        constraints() {
            let constr = this.field.constraints

            return constr
        }
    },
    watch: {
        content(val) {
            this.check(parseFloat(val))
        }
    },
    methods: {
        check(val) {
            this.errors = []

            if (val == null && this.constraints.required) {
                this.errors.push(this.translator("identityField.requiredField"))
            }
            
            if (this.constraints.length !== undefined) {
                if (val > this.constraints.length.max && this.constraints.length.max !== null) {
                    this.errors.push(
                        this.translator("identityField.cantBeMoreThen", {
                            max: this.constraints.length.max
                        })
                    )
                }

                if (val < this.constraints.length.min && this.constraints.length.min !== null) {
                    this.errors.push(
                        this.translator("identityField.cantBeLessThen", {
                            min: this.constraints.length.min
                        })
                    )
                }
            }

            this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
        }
    },
    mounted() {
        if (this.constraints.default && this.content === null && this.content == "") {
            this.content = parseFloat(this.constraints.default)
            
            return
        }

        this.check(this.content)
    }
}
</script>